export default "__VITE_ASSET__0bb2db4d__"